module.exports = __webpack_public_path__ + "images/Alert_2dace13.png";